export enum LoadGeneratorType {
  External = 'EXTERNAL',
  Webhook = 'WEBHOOK'
}
